import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
} from "recharts";

import Card from "../UI/Card";
// import HypersensibilityPic from "../../images/hypersensibility.png";

import { ProgressContext } from "../context/progress-context";

import Button from "../UI/Button";

// import AnswerItem from "./AnswerItem";

import "./AnswerList.css";

const AnswerList = ({ items }) => {
  const progress = useContext(ProgressContext);
  const { t } = useTranslation();

  const hyperRangePosition = (hyperVal) => {
    if (hyperVal > 5 && hyperVal < 15) {
      const graphData = [
        { name: "Hypo", hypersensitivity: 5 },
        { name: t("result.row11_point"), hypersensitivity: hyperVal },
        { name: "Normo", hypersensitivity: 15 },
        { name: "Hyper", hypersensitivity: 25 },
      ];
      return graphData;
    } else if (hyperVal > 15 && hyperVal < 25) {
      const graphData = [
        { name: "Hypo", hypersensitivity: 5 },
        { name: "Normo", hypersensitivity: 15 },
        { name: t("result.row11_point"), hypersensitivity: hyperVal },
        { name: "Hyper", hypersensitivity: 25 },
      ];
      return graphData;
    } else if (hyperVal === 5) {
      const graphData = [
        { name: t("result.row11_point_hypo"), hypersensitivity: 5 },
        { name: "Normo", hypersensitivity: 15 },
        { name: "Hyper", hypersensitivity: 25 },
      ];
      return graphData;
    } else if (hyperVal === 15) {
      const graphData = [
        { name: "Hypo", hypersensitivity: 5 },
        { name: t("result.row11_point_normo"), hypersensitivity: 15 },
        { name: "Hyper", hypersensitivity: 25 },
      ];
      return graphData;
    } else if (hyperVal === 25) {
      const graphData = [
        { name: "Hypo", hypersensitivity: 5 },
        { name: "Normo", hypersensitivity: 15 },
        { name: t("result.row11_point_hyper"), hypersensitivity: 25 },
      ];
      return graphData;
    }
  };

  const convertedGraphData = hyperRangePosition(items.page4.sum);

  const renderChart = (
    <LineChart
      width={350}
      height={100}
      data={convertedGraphData}
      className="hypersensibility_graph"
    >
      <Line type="monotone" dataKey="hypersensitivity" stroke="#97cc6d" />
      <CartesianGrid stroke="#04BC79" />
      <XAxis dataKey="name" />
      <YAxis domain={[0, 25]} />
      <Tooltip />
      <Legend />
    </LineChart>
  );

  return (
    <Card>
      <h4>{t("result.title1")}</h4>
      <table>
        <thead>
          <tr>
            <th>{t("result.row1_header1")}</th>
            <th>{t("result.row1_header2")}</th>
            <th>{t("result.row1_header3")}</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <th>{t("result.row2_header")}</th>
            <td>
              {items.page9.hypersensibility}:
              {items.page9.valueOfHypersensibility}
            </td>
            <td>
              {items.page15.hypersensibility}:
              {items.page15.valueOfHypersensibility}
            </td>
          </tr>
          <tr>
            <th>{t("result.row3_header")}</th>
            <td>
              {t("result.row3_data1")} {items.page2.answer1},<br />
              {t("result.row3_data2")}
              {items.page2.answer2},<br />
              {t("result.row3_data3")} {items.page2.answer3}
            </td>
            <td>
              {t("result.row3_data1")} {items.page16.answer1},{" "}
              {t("result.row3_data2")}
              {items.page16.answer2},<br />
              {t("result.row3_data3")} {items.page16.answer3}
            </td>
          </tr>
          <tr>
            <th>{t("result.row4_header")}</th>
            <td>{items.page7.value1}</td>
            <td>{items.page13.value1}</td>
          </tr>
          <tr>
            <th>{t("result.row5_header")}</th>
            <td>{items.page7.value2}</td>
            <td>{items.page13.value2}</td>
          </tr>
          <tr>
            <th>{t("result.row6_header")}</th>
            <td>{items.page7.value3}</td>
            <td>{items.page13.value3}</td>
          </tr>
          <tr>
            <th>{t("result.row7_header")}</th>
            <td>{items.page7.value4}</td>
            <td>{items.page13.value4}</td>
          </tr>
          <tr>
            <th>{t("result.row8_header")}</th>
            <td>{items.page8.valueOfSelectedColor2}</td>
            <td>{items.page14.valueOfSelectedColor}</td>
          </tr>
        </tbody>
      </table>
      <h4>{t("result.title2")}</h4>
      <table>
        <thead>
          <tr>
            <th>{t("result.row9_header1")}</th>
            <th>{t("result.row9_header2")}</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <th>{t("result.row10_header")}</th>
            <td>
              {t("result.row10_data1")} {items.page3.typeG},{" "}
              {t("result.row10_data2")} {items.page3.typeA},{" "}
              {t("result.row10_data3")}
              {items.page3.typeB}, {t("result.row10_data4")} {items.page3.typeS}
            </td>
          </tr>
          <tr>
            <th>
              {t("result.row11_header")}
              {/* <img
                className="hypersensibility_picture"
                src={HypersensibilityPic}
                alt="Hypersensibility Example"
              /> */}
              {renderChart}
            </th>
            <td>
              {items.page4.sum} {t("result.row11_data")}
            </td>
          </tr>
          <tr>
            <th>{t("result.row12_header")}</th>
            <td>{items.page8.valueOfSelectedColor1}</td>
          </tr>
          <tr>
            <th>{t("result.row13_header")}</th>
            <td>{items.page10.valueOfVolume}</td>
          </tr>
          <tr>
            <th>{t("result.row14_header")}</th>
            <td>
              {items.page11.time} {t("result.row14_data")}
            </td>
          </tr>
          <tr>
            <th>{t("result.row15_header")}</th>
            <td>
              {t("result.row15_data1")} {items.page19.value1},<br />
              {t("result.row15_data2")} {items.page19.value2}
            </td>
          </tr>
          <tr>
            <th>{t("result.row16_header")}</th>
            <td>{items.page17.tiredness}</td>
          </tr>
          <tr>
            <th>{t("result.row17_header")}</th>
            <td>
              {t("result.row17_data1")} {items.page17.sadness},<br />
              {t("result.row17_data2")} {items.page17.fear},<br />
              {t("result.row17_data3")} {items.page17.frustration}
            </td>
          </tr>
          <tr>
            <th>{t("result.row18_header")}</th>
            <td>{items.page18.hyperactivity}</td>
          </tr>
          <tr>
            <th>{t("result.row19_header")}</th>
            <td>{items.page18.satisfactionOfRelaxationLaboratory}</td>
          </tr>
          <tr>
            <th>{t("result.row20_header")}</th>
            <td>
              {t("result.row20_data1")} {items.page5.value1},<br />
              {t("result.row20_data2")} {items.page5.value2},{" "}
              {t("result.row20_data3")} {items.page5.value3},{" "}
              {t("result.row20_data4")} {items.page5.value4}{" "}
            </td>
          </tr>
          <tr>
            <th>{t("result.row21_header")}</th>
            <td>
              {t("result.row21_data1")} {items.page6.value1},<br />
              {t("result.row21_data2")} {items.page6.value2},<br />
              {t("result.row21_data3")} {items.page6.value3},<br />
              {t("result.row21_data4")} {items.page6.value4},<br />
              {t("result.row21_data5")} {items.page6.value5}
            </td>
          </tr>
        </tbody>
      </table>
      <Link to="/">
        <Button
          type="button"
          value={t("result.button_back_survey")}
          onClick={progress.resetProgress}
        />
      </Link>
    </Card>
  );
};

export default AnswerList;
